import { getGooglePhotoProxyUrlFromName, getGooglePhotoProxyUrl } from '@/utils/googlePhotoProxy';

/**
 * GooglePlacePhoto - Represents a Google Places photo identifier
 * Backend now sends identifiers only (name or photo_reference), not URLs
 */
export default class GooglePlacePhoto {
  name?: string; // New format identifier
  photo_reference?: string; // Old format identifier (fallback)
  heightPx?: number;
  widthPx?: number;
  author?: { displayName?: string; uri?: string | null } | null;

  constructor(data: Record<string, unknown>) {
    this.name = data.name as string | undefined;
    this.photo_reference = data.photo_reference as string | undefined;
    this.heightPx = data.heightPx as number | undefined;
    this.widthPx = data.widthPx as number | undefined;
    this.author = data.author as { displayName?: string; uri?: string | null } | null | undefined;
  }

  formatPhotoURI(maxSize: number): string {
    // Use backend endpoint URL for browser caching (30-day TTL)
    if (this.name) {
      return getGooglePhotoProxyUrlFromName(this.name, maxSize);
    }
    if (this.photo_reference) {
      return getGooglePhotoProxyUrl(this.photo_reference, maxSize);
    }
    return '';
  }
}
